(function () {
  "use strict";

  angular.module("sempraWebapp").factory("alarmsStore", alarmsStoreFactory);

  /** @ngInject */
  function alarmsStoreFactory(
    dispatcher,
    EventEmitter,
    devicesStore,
    ActionTypesEnum,
    AlarmStateEnum,
    PointTypeEnum,
    modelUtils
  ) {
    var AlarmsStore = new EventEmitter(),
      alarmsImmutable = null;

    AlarmsStore.events = Object.freeze({
      CHANGE: "change"
    });

    AlarmsStore.getAlarms = function () {
      return alarmsImmutable !== null ? alarmsImmutable.toJSON() : null;
    };

    AlarmsStore.getAlarmsParams = function () {
      return alarmsImmutable !== null ? alarmsImmutable.toJSON() : null;
    };

    AlarmsStore.getAlarmsBySerial = function (deviceSerial) {
      return alarmsImmutable !== null
        ? alarmsImmutable.toJSON().find(function (deviceAlarms) {
            return deviceAlarms.deviceSerial === deviceSerial;
          })
        : null;
    };

    AlarmsStore.deleteStore = function () {
      alarmsImmutable = null;
    };

    AlarmsStore.dispatchToken = dispatcher.register(function (actionData) {
      switch (actionData.type) {
        case ActionTypesEnum.GET_DEVICES:
          dispatcher.waitFor([devicesStore.dispatchToken]);
          alarmsImmutable = Immutable.fromJS(normalize(actionData.payload));
          AlarmsStore.emit(AlarmsStore.events.CHANGE);
          break;
        case ActionTypesEnum.GET_ALARM_FROM_DASHBOARD_MESSAGE:
          alarmsImmutable = Immutable.fromJS(actionData.payload);
          AlarmsStore.emit(AlarmsStore.events.CHANGE);
          break;
      }
    });

    return AlarmsStore;

    function normalize(devicesJson) {
      var alarms = [];

      devicesJson.forEach(function (deviceJson) {
        var device = {
          deviceSerial: deviceJson.deviceSerial,
          name: deviceJson.points ? deviceJson.points.find(function (pointJson) {
            return pointJson.pointType === PointTypeEnum.WASH_FACILITY;
          }).name : null,
          alarms: []
        };
        this.push(device);
        findAlarms(device.alarms, deviceJson);
      }, alarms);

      return alarms;
    }

    function findAlarms(resultDeviceAlarms, jsonData) {
      if (jsonData.feeds) {
        jsonData.feeds.forEach(function (feedJson) {
          if (feedJson.alarmState !== AlarmStateEnum.NORMAL) {
            var newAlarm = {
              pointName: jsonData.name
            };
            modelUtils.extendObject(newAlarm, feedJson);
            this.push(newAlarm);
          }
        }, resultDeviceAlarms);
      }

      if (jsonData.points) {
        jsonData.points.forEach(function (pointJson) {
          findAlarms(resultDeviceAlarms, pointJson);
        });
      }
    }
  }
})();
